var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDuplicateNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-duplicate"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "duplicate",
    clipPath: "url(#clip-duplicate)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33284",
    "data-name": "Group 33284",
    transform: "translate(7909.853 -15587.764)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "copy",
    d: "M14.127,3H9.358A3.188,3.188,0,0,0,6.179,6.179,3.188,3.188,0,0,0,3,9.358v4.769a3.188,3.188,0,0,0,3.179,3.179h4.769a3.188,3.188,0,0,0,3.179-3.179,3.188,3.188,0,0,0,3.179-3.179V6.179A3.188,3.188,0,0,0,14.127,3Zm-1.59,11.127a1.594,1.594,0,0,1-1.59,1.59H6.179a1.594,1.594,0,0,1-1.59-1.59V9.358a1.594,1.594,0,0,1,1.59-1.59h4.769a1.594,1.594,0,0,1,1.59,1.59Zm3.179-3.179a1.594,1.594,0,0,1-1.59,1.59V9.358a3.188,3.188,0,0,0-3.179-3.179H7.769a1.594,1.594,0,0,1,1.59-1.59h4.769a1.594,1.594,0,0,1,1.59,1.59Z",
    transform: "translate(-7912.506 15585.111)",
    fill: "#6776cb"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuplicateNew);
export default __webpack_public_path__ + "static/media/duplicate-new.8830b9615eaff0c8149a86cffff0f1a9.svg";
export { ForwardRef as ReactComponent };